module.exports = __webpack_public_path__ + "media/images/guideline/G_03-efe3a8415da0d44ae35f3cf7cfa81e30.jpg";